<template>
  <div
    class="table__list"
    :style="{width: props.tableWidth + 'px'}"
  >
    <ListRow
      v-for="(row, rowIndex) in props.tableData"
      :key="row.id"
      :class="{_isDeleted: row.isDeleted}"
      :row="row"
      :row-index="rowIndex"
      :table-width="tableWidth"
      :column-list="columnList"
      :table-data="props.tableData"
      @update-row="args => emit('update-row', args)"
      @edit-row="emit('edit-row', row)"
    />
  </div>
</template>

<script setup>
import { defineProps } from "vue";
import ListRow from "@/components/table/ListRow.vue";

const props = defineProps({
  tableWidth: {
    type: Number,
    required: true
  },
  columnList: {
    type: Array,
    required: true
  },
  tableData: {
    type: Array,
    required: true
  }
});

const emit = defineEmits(["edit-row"]);
</script>

<style lang="scss" scoped>
.table {
  &__list {
    height: calc(100vh - 279px);
  }
}
</style>
